module.exports = __webpack_public_path__ + "static/media/lostwind.736072f6.jpg";